// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteCashRegisterMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteCashRegisterMutationResult = { __typename?: 'Mutation', deleteCashRegister: boolean };

export const DeleteCashRegisterGql = gql`
    mutation DeleteCashRegister($id: Int!) {
  deleteCashRegister(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCashRegisterInjectable extends Apollo.Mutation<DeleteCashRegisterMutationResult, DeleteCashRegisterMutationVariables> {
    override document = DeleteCashRegisterGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */